'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var useField = require('../../hooks/useField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Hidden(props) {
  var _useField = useField.useField(_rollupPluginBabelHelpers.objectSpread2({
      type: 'text'
    }, props)),
    informed = _useField.informed,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  return render( /*#__PURE__*/React__default["default"].createElement("input", _rollupPluginBabelHelpers["extends"]({}, informed, userProps, {
    ref: ref,
    type: "hidden"
  })));
}

exports.Hidden = Hidden;
